<template>
  <router-view/>
</template>

<script>
export default {
  name: 'default-layout'
}
</script>

<style scoped>

</style>
